import services from '@/services.js'

export default {
  setCurrentStep: ({ commit }, number) => {
    commit('SET_CURRENT_STEP', number)
  },

  updateInfoStep: ({ commit }, data) => {
    commit('SET_INFO_STEP', data)
  },

  updateInfoPropStep: ({ commit }, prop, data) => {
    commit('SET_PROP_INFO_STEP', prop, data)
  },

  initCommit: ({ commit }, nameCommit) => {
    commit(nameCommit)
  },

  setModalComponent: ({ commit }, data) => {
    commit('SET_MODAL', data)
  },

  closeModalComponent: ({ commit }) => {
    commit('CLOSE_MODAL')
  },

  successPurcharse: ({ commit }) => {
    commit('RESET_STATE_STEP')
  },

  validateBillingInfo: ({ commit }, { prop, info, organizationId }) => {
    return new Promise((resolve, reject) => {
      services
        .validatebillinginfo(organizationId, info)
        .then(({ data }) => {
          commit('SET_COSTUMER', data.data)
          commit('SET_PROP_INFO_STEP', { prop, data: info })
          resolve(true)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },

  createPaymentIntent: ({ commit }, { info, organizationId }) => {
    return new Promise((resolve, reject) => {
      services
        .createpaymentintent(organizationId, info)
        .then(({ data }) => {
          commit('SET_CURRENT_STEP', 4)
          commit('SET_PROP_INFO_STEP', { prop: 'tax', data: data.data.iva })
          commit('SET_PROP_INFO_STEP', { prop: 'totalPrice', data: data.data.totalPrice })
          commit('SET_PROP_INFO_STEP', { prop: 'mount', data: data.data.price })
          resolve(data)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },
}
